import React, { useEffect, useContext, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import "../../styles/globals.css";
import "./RegistNewPasswordPage.css";
import { Form, Input, Row, Col } from "antd";
import { ExclamationCircleOutlined, WarningFilled } from "@ant-design/icons";
import { validatePassword } from "../../utils/validationUtils";
import { showToast, encodeToBase64 } from "../../utils/commonUtils";
import { resetPassword, resetPasswordAfterLogin } from "../../services/service";

function RegistNewPasswordPage() {
  useEffect(() => {}, []);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { globalEmailAddress, globalAccessToken, globalLoginUserInfo } =
    useContext(AppContext);
  const [errors, setErrors] = useState({
    mail: false,
  });
  const [errorMessage, setErrorMessage] = useState(null);
  const [inputPasswordValue, setInputPasswordValue] = useState(null);

  const passwordInput = useRef(null);
  useEffect(() => {
    passwordInput.current.input.focus();
  }, [errors?.password]);

  /**
   * 値変更時の処理
   * @param {string} fieldName - フィールド名
   */
  const onValueChange = async (fieldName) => {
    try {
      await form.validateFields([fieldName]);
      setErrors({ ...errors, [fieldName]: false });
      setErrorMessage(null);
      setInputPasswordValue(true);
    } catch (error) {
      setInputPasswordValue(false);
      setErrors({ ...errors, [fieldName]: true });
      setErrorMessage(
        "半角英数字、記号を組み合わせた13文字以上で入力してください"
      );
    }
  };

  // パスワードを再設定ボタンを押したときの処理
  const handlePasswordResetClick = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const { password } = values;

      try {
        let data = "";
        if (location.pathname?.includes("mypage")) {
          data = await resetPasswordAfterLogin(
            globalAccessToken,
            encodeToBase64(password),
            globalEmailAddress,
            globalLoginUserInfo?.userInfo.kanjiLast,
            globalLoginUserInfo?.userInfo.kanjiFirst
          );
        } else {
          data = await resetPassword(
            globalAccessToken,
            encodeToBase64(password),
            globalEmailAddress
          );
        }
        if (data.result.status === "OK") {
          if (location.pathname?.includes("mypage")) {
            // マイページに遷移
            navigate("/mypage/menu");
            showToast("パスワードを変更しました", "success");
          } else {
            // ログイン画面に遷移
            navigate("/account-login");
            showToast("パスワードを再設定しました", "success");
          }
        } else {
          // エラーメッセージセット
          setErrorMessage(data?.result?.error_message);
        }
      } catch (error) {
        console.error("Error resetPassword:", error);
        showToast("パスワードの再設定に失敗しました", "error");
      }
    } catch (error) {
      const fieldErrors = error.errorFields.reduce((acc, field) => {
        acc[field.name[0]] = true;
        return acc;
      }, {});
      setErrors(fieldErrors);
      showToast("入力に不備があります。ご確認ください", "error");
    }
  };

  return (
    <div className="reset-password">
      <div className="main-area">
        <div className="title">新しいパスワード再設定</div>
        <div className="detail">
          新しいパスワードを入力し、「パスワードを再設定」ボタンをクリックしてください。
        </div>
        <div className="form">
          <Form
            form={form}
            name="password-reset"
            layout="vertical"
            initialValues={{ remember: true }}
          >
            <Row gutter={16} className="password-row">
              <span className="explanation-string">
                ※半角英数字、記号を組み合わせた13文字以上
              </span>
              <Col span={24}>
                <Form.Item
                  className="ant-label"
                  label="パスワード"
                  name="password"
                  rules={[
                    { required: true, message: "パスワードを入力してください" },
                    { validator: validatePassword },
                  ]}
                  validateTrigger="onChange"
                >
                  <Input.Password
                    className="ant-input"
                    placeholder="パスワード"
                    ref={passwordInput}
                    suffix={
                      errors.password ? <ExclamationCircleOutlined /> : null
                    }
                    onChange={() => {
                      onValueChange("password");
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            {errorMessage && (
              <div className="error-area">
                <div className="icon-area">
                  <WarningFilled className="icon" />
                </div>
                <label>{errorMessage}</label>
              </div>
            )}
          </Form>
        </div>
        <GeneralButton
          buttonLabel={"パスワードを再設定"}
          type={
            Object.values(errors).some((error) => error) || !inputPasswordValue
              ? "disabled"
              : "primary-blue"
          }
          onClick={() => handlePasswordResetClick()}
        />
      </div>
    </div>
  );
}
export default RegistNewPasswordPage;
